import { z } from 'zod'

export function usePromptMixin() {
	return {
		data() {
			return {
				prompt: {
					schema: null,
					value: undefined,
					error: undefined,
					field_state: { touched: false, dirty: false }
				}
			}
		},

		methods: {
			prompt_set_schema(schema, initial_value) {
				this.prompt.schema = schema || null
				this.prompt.value = initial_value
				this.prompt.error = undefined
				this.prompt.field_state = { touched: false, dirty: false }
			},

			prompt_handle_input(value) {
				this.prompt.value = value
				this.prompt.field_state.dirty = true
				if (this.prompt.error) {
					this.prompt_validate()
				}
			},

			prompt_handle_blur() {
				this.prompt.field_state.touched = true
				if (this.prompt.field_state.dirty) {
					this.prompt_validate()
				}
			},

			prompt_validate() {
				if (!this.prompt.schema) {
					this.prompt.error = undefined
					return true
				}
				try {
					this.prompt.schema.parse(this.prompt.value)
					this.prompt.error = undefined
					return true
				} catch (error) {
					if (error instanceof z.ZodError) {
						const msg = (error.issues && error.issues[0] && error.issues[0].message) || 'Invalid value'
						this.prompt.error = msg
					}
					return false
				}
			}
		}
	}
}
